import React from "react";
import Header from "../layouts/Header";
import Sliders from "../components/Slider";
import About from "../layouts/About";
import Partner from "../layouts/Partner";
import Bouns from "../layouts/Bouns";
import Footer from "../layouts/Footer";

function Home({ globalData }) {
  return (
    <div className="et-boc">
      <Header />
      <div id="et-main-area">
        <div id="main-content">
          <div className="et-l et-l--body">
            <div className="et_builder_inner_content et_pb_gutters3">
              <Sliders sliderAffiliate={globalData?.sliders?.affiliate || []} />
              <About sliderAbout={globalData?.sliders?.about || []} />
              <Partner />
              <Bouns socialLinks={globalData?.socialLinks || []} generel={globalData?.general || {}} />
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
